import { getStereotypes, getTechnicalColumnStereotype } from '@/endpoints'
import { StereotypeDto, TechnicalColumnStereotypeDto } from '@/endpoints/models'
import { apiCallAction } from '@/store/utils'

import { STEREOTYPE_LOAD, STEREOTYPE_LOAD_COLUMNS } from './constants'

interface LoadStereotypes {
	metadata: {
		type: StereotypeDto.TypeEnum
	},
	payload: StereotypeDto[]
	type: typeof STEREOTYPE_LOAD
}

interface LoadStereotypeColumns {
	metadata: {
		stereotypeId: number
	},
	payload: TechnicalColumnStereotypeDto[]
	type: typeof STEREOTYPE_LOAD_COLUMNS
}

export const loadStereotypes = (type: StereotypeDto.TypeEnum) =>
	apiCallAction<LoadStereotypes>(
		() => getStereotypes({ type }),
		STEREOTYPE_LOAD,
		{
			type,
		},
	)

export const loadStereotypeColumns = (
	stereotypeId: number,
	technologyId: number,
) =>
	apiCallAction<LoadStereotypeColumns>(
		() => getTechnicalColumnStereotype(stereotypeId, technologyId),
		STEREOTYPE_LOAD_COLUMNS,
		{ stereotypeId },
	)

export type Actions = LoadStereotypes | LoadStereotypeColumns
